import React, { useMemo, useState } from 'react';
import { Modal, Spin, Upload, Alert } from 'antd';
import { useValidateSSMagicLinkCSV } from '../../../../query/csv-utilities';
import { Button } from '../../../../components/ui';
import CsvErrorButton from './CsvErrorButton';
import { useConvertSSMagicLinkCsv } from '../../../../mutation/csv-utilities';
import SelfServeMagicLinkCSVTable from './SelfServeMagicLinkCSVTable';

const { Dragger } = Upload;

export default function SelfServeMagicLinkInjectionModal({
  isVisible,
  onClose,
}) {
  const [file, setFile] = useState(null);
  const { isFetching, data } = useValidateSSMagicLinkCSV(file);
  const { mutateAsync, isLoading } = useConvertSSMagicLinkCsv();
  const renderCsvResult = useMemo(() => {
    if (!data || !file) return null;
    if (data.valid) {
      const hasWarnings = !!(data?.variablesWarnings?.length > 0);
      return (
        <div className="w-full flex items-center space-x-2">
          <Alert
            className="w-full"
            message={
              hasWarnings
                ? 'The CSV is valid with warnings'
                : 'The CSV is valid'
            }
            type={hasWarnings ? 'warning' : 'success'}
          />
          <div style={{ display: 'flex' }}>
            {!!data.variablesWarnings.length && (
              <CsvErrorButton isWarningOnly result={data} />
            )}
            <Button
              disabled={isLoading}
              style={{ width: 250, marginLeft: hasWarnings ? 10 : 0 }}
              onClick={() => {
                mutateAsync(file).then(() => setFile(null));
              }}
            >
              Generate Self-Serve Link
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div className="w-full flex items-center space-x-2">
        <Alert
          className="w-full"
          message={`Uploaded CSV has one or more error(s): ${data.message}`}
          type="error"
        />
        {data.errors.length && <CsvErrorButton result={data} />}
      </div>
    );
  }, [data, file, isLoading, mutateAsync]);

  return (
    <Modal
      closable={!isLoading}
      maskClosable={!isLoading}
      title="Self Serve Magic Link Injection"
      visible={isVisible}
      width={1200}
      onCancel={onClose}
    >
      <div style={{ marginBottom: 10 }}>
        <a href="/sample_ss_convert.csv" target="_blank">
          Download Sample CSV
        </a>
      </div>
      <Spin spinning={isFetching || isLoading}>
        <Dragger
          accept="text/csv"
          beforeUpload={uploadedFile => {
            setFile(uploadedFile);
            return false;
          }}
          fileList={file ? [file] : []}
          multiple={false}
          onRemove={() => setFile(null)}
        >
          <p className="ant-upload-text">Upload your CSV file here</p>
          <p className="ant-upload-hint">
            The CSV will have self serve magic link injected
          </p>
        </Dragger>
        {renderCsvResult}
      </Spin>
      <SelfServeMagicLinkCSVTable />
    </Modal>
  );
}
